import Modal from 'react-modal';
import { Button, Grid, IconButton, TextField } from '@mui/material';
import { Close } from '@mui/icons-material';
import AppsflyerLogo from "../../Assets/Images/logos_appsflyer.webp"
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { channelType } from '../../api/appsflyer/transformer';
import { connectAccountApi, closeConnectingAppsflyer } from '../../api/appsflyer/action';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: "#ffff",
        width: "400px",
        padding: "0",
        zIndex: 9000000000000,
        position: "absolute"
    },
};

function AppsflyerConnectModal({ isConnecting, connectAccountApi, close }) {
    const [state, setState] = useState({
        appsflyer_access_token: "",
        token_name: ""
    });

    useEffect(() => {
        close();
    }, []);

    const handleChange = (property, value) => {
        setState({ ...state, [property]: value });
    }

    return (
        <Modal isOpen={isConnecting} style={customStyles}>
            <div style={{ width: "100%", height: "40px", borderBottom: "1px solid #eee", padding: "10px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div>
                    <b><img src={AppsflyerLogo} style={{ width: "20px", marginRight: "5px" }} alt="Shopify" /> Connect your appsflyer account</b>
                </div>
                <div>
                    <IconButton aria-label="save" onClick={close}>
                        <Close sx={{
                            borderRadius: '4px',
                            padding: '4px',
                            backgroundColor: '#F2F2F2'
                        }}
                        />
                    </IconButton>
                </div>
            </div>
            <div style={{ width: "100%", height: "calc(100% - 40px)", position: "relative", zIndex: 90000000, backgroundColor: "#ffff", justifyContent: "center", alignItems: "center", display: "flex", flexDirection: "column", marginTop: '20px' }}>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", width: "70%" }}>
                    <h3 style={{ textAlign: "left", marginBottom: "14px" }}><b>Appsflyer token name</b></h3>
                    <Grid item xs={12} style={{ padding: '4px 0 4px 0', marginBottom: "20px" }}>
                        <TextField
                            style={{ width: '100%' }}
                            placeholder='Enter access token name'
                            size="small"
                            id="outlined-basic"
                            InputLabelProps={{ shrink: true }}
                            label="Access token name"
                            variant="outlined"
                            onChange={(e) => handleChange("token_name", e.target.value)}
                        />
                    </Grid>
                    <h3 style={{ textAlign: "left", marginBottom: "14px" }}><b>Appsflyer access token</b></h3>
                    <Grid item xs={12} style={{ padding: '4px 0 4px 0', marginBottom: "20px" }}>
                        <TextField
                            style={{ width: '100%' }}
                            placeholder='*******************************'
                            size="small"
                            id="outlined-basic"
                            InputLabelProps={{ shrink: true }}
                            label="Access token"
                            variant="outlined"
                            onChange={(e) => handleChange("appsflyer_access_token", e.target.value)}
                        />
                    </Grid>
                </div>
                <div style={{ width: "100%", borderTop: "1px solid #eee", padding: "10px", display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                    <div>
                        <Button
                            sx={{ padding: "5px 20px", textAlign: "right", float: "right", borderRadius: "10px", textTransform: "none" }}
                            variant="contained"
                            onClick={() => connectAccountApi({
                                redirect_url: "selectchannels",
                                ...state
                            })}
                        >Connect Account</Button>
                    </div>
                </div>
            </div>
        </Modal>
    )
}
const mapStateToProps = state => ({
    isConnecting: state[channelType].isConnecting,
})

const mapDispatchToProps = dispatch => ({
    connectAccountApi: (_) => dispatch(connectAccountApi(_)),
    close: () => dispatch(closeConnectingAppsflyer()),
})

export default (connect(mapStateToProps, mapDispatchToProps)(AppsflyerConnectModal));

